import {
  StepProgressBar,
  StepProgressBars,
  StepProgressLabel,
} from "../CancelPolicy.style";

type CancelPolicyStepperProps = {
  label?: string;
  activeStepIndex: number;
  totalSteps: number;
};

export const CancelPolicyStepper = ({
  label,
  activeStepIndex,
  totalSteps,
}: CancelPolicyStepperProps) => {
  if (totalSteps <= 0) {
    return null;
  }

  return (
    <div>
      {label ? <StepProgressLabel>{label}</StepProgressLabel> : null}
      <StepProgressBars>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <StepProgressBar
            key={`cancel-step-${index}`}
            $active={index <= activeStepIndex}
          />
        ))}
      </StepProgressBars>
    </div>
  );
};
